import levels from "#simplified-runtime-levels" with { type: "json" };

export function getLevels() {
  return levels;
}

export function getSimplifiedLevels() {
  return levels;
}
